export default __webpack_public_path__ + "static/media/poster-1.c514113a.jpg";